module.exports = __webpack_public_path__ + "img/LKA.1b05e818.svg";